module.exports = __webpack_public_path__ + "static/media/envelope3.629e5d3b.jpg";